module.exports = __webpack_public_path__ + "static/media/success.9df798a3.svg";